import React from 'react';
import { Check, X, AlertCircle, Loader2 } from 'lucide-react';

const FormField = ({ 
  label, 
  error, 
  children, 
  required = false,
  helpText 
}) => {
  return (
    <div className="space-y-2">
      {typeof label === 'string' ? (
        <label className="block font-semibold text-blue-900">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      ) : label}
      {children}
      {helpText && (
        <p className="text-sm text-gray-600 flex items-center">
          <AlertCircle className="h-4 w-4 mr-1" />
          {helpText}
        </p>
      )}
      {error && (
        <p className="text-sm text-red-600 flex items-center">
          <X className="h-4 w-4 mr-1" />
          {error}
        </p>
      )}
    </div>
  );
};

const FormSubmissionStatus = ({ status, message }) => {
  const statusConfig = {
    loading: {
      icon: <Loader2 className="h-5 w-5 animate-spin" />,
      bgColor: 'bg-blue-50',
      textColor: 'text-blue-700',
      borderColor: 'border-blue-200'
    },
    success: {
      icon: <Check className="h-5 w-5" />,
      bgColor: 'bg-green-50',
      textColor: 'text-green-700',
      borderColor: 'border-green-200'
    },
    error: {
      icon: <X className="h-5 w-5" />,
      bgColor: 'bg-red-50',
      textColor: 'text-red-700',
      borderColor: 'border-red-200'
    }
  };

  const config = statusConfig[status];

  return (
    <div className={`p-4 rounded-lg border ${config.bgColor} ${config.borderColor} flex items-center space-x-3`}>
      <div className={config.textColor}>
        {config.icon}
      </div>
      <p className={`${config.textColor} font-medium`}>
        {message}
      </p>
    </div>
  );
};

const ProgressBar = ({ currentStep, totalSteps }) => {
  return (
    <div className="w-full bg-gray-200 rounded-full h-2 mb-6">
      <div 
        className="bg-gradient-to-r from-blue-600 to-cyan-600 h-2 rounded-full transition-all duration-300"
        style={{ width: `${(currentStep / totalSteps) * 100}%` }}
      />
    </div>
  );
};

export { FormField, FormSubmissionStatus, ProgressBar };
